import { DateTime } from "luxon";
import { assertIsDateTimeValid } from "./assertIsDateTimeValid";

export function createDateTimeFromAwsDateTime(
  awsDate: string,
  contextName: string
): DateTime {
  const result = DateTime.fromISO(awsDate);

  assertIsDateTimeValid(result, contextName);

  return result;
}

export function createAwsDateTimeFromDateTime(awsDate: DateTime): string {
  assertIsDateTimeValid(awsDate, "awsDate");

  return awsDate.toUTC().toISO();
}
